import type { FunctionComponent, HTMLAttributes } from "react";

import { Container } from "./styles";

export type Props = HTMLAttributes<HTMLDivElement> & {
  isExpand: boolean;
  toggleMessage: {
    after: string;
    before: string;
  };
};

export const SearchResultListToggle: FunctionComponent<Props> = ({
  isExpand,
  toggleMessage,
  ...props
}) => (
  <Container $isExpand={isExpand} {...props}>
    {isExpand ? toggleMessage.after : toggleMessage.before}
  </Container>
);

SearchResultListToggle.displayName = "SearchResultListToggle";
